import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { apiDriverApp } from '../../../../../libs/apiDriverApp';

export const downloadVendorDriverReport = async () => {
    try {
        const { data } = await apiDriverApp.get('/api/vendors/vendor-users/driver-report/');
        const results = (data && data.results) || [];

        if (results.length === 0) {
            Swal.fire('No Data', 'No vendor driver data found.', 'info');
            return;
        }

        const formattedData = results.map((row) => ({
            Vendor: row.vendor_name || '',
            "First Name": row.first_name || '',
            "Last Name": row.last_name || '',
            Email: row.email || '',
            Role: row.role || '',
            "Mobile Phone": row.mobile_phone || '',
            "Work Email": row.work_email || '',
            Status: row.active ? 'Active' : 'Inactive',
            "App Version": row.app_version || 'Unknown',
            "OS Notification Permission": row.os_notification_permission || 'Unknown',
            "Push Notifications Enabled": row.push_notifications_enabled ? 'Yes' : 'No',
            "OS Location Permission": row.os_location_permission || 'Unknown',
            "Location Permission Updated": row.os_location_permission_updated_at
                ? new Date(row.os_location_permission_updated_at).toLocaleString()
                : '',
        }));

        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Vendor Drivers");

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(excelBlob, "vendor_driver_report.xlsx");
    } catch (error) {
        console.error("Error downloading vendor driver report:", error);
        Swal.fire('Error', 'Failed to download the vendor driver report.', 'error');
    }
};
